import { render, staticRenderFns } from "./StudentComingSoonDialog.vue?vue&type=template&id=445ee354&scoped=true&"
import script from "./StudentComingSoonDialog.vue?vue&type=script&lang=js&"
export * from "./StudentComingSoonDialog.vue?vue&type=script&lang=js&"
import style0 from "./StudentComingSoonDialog.vue?vue&type=style&index=0&id=445ee354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ee354",
  null
  
)

export default component.exports